module.exports = __webpack_public_path__ + "static/media/rounded-blue-check.55e8a392.svg";